import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import {
  ElaborationEntityConstants
} from 'src/app/pratica/components/wizard-creazione/constants/elaboration-entity-constants';
import {
  CreazionePraticaStoreService
} from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica-store.service';
import {
  CreazionePraticaTipologicheService
} from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica-tipologiche.service';
import { filterElaborationEntityClean } from 'src/app/pratica/components/wizard-creazione/utils/wizard-utils';
import { TipoNatura } from '../../models/tipologiche/tipo-natura';
import { TipoVisibilita } from '../../models/tipologiche/tipo-visibilita';
import { AppData } from 'src/app/data-store';
import { Router} from '@angular/router';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { TipoMotivazione } from '../../models/tipologiche/tipo-motivazione';

@Component({
  selector: 'app-dati-generali-fascicolo-common',
  templateUrl: './dati-generali-fascicolo-common.component.html',
  styleUrls: ['./dati-generali-fascicolo-common.component.css']
})
export class DatiGeneraliFascicoloCommonComponent implements OnInit, OnDestroy {

  constructor( private helpers: HelpersService, private formBuilder: FormBuilder, private router: Router,
               private creazionePraticaStoreService: CreazionePraticaStoreService,private viewManager: ViewManagerService,
               private tipologicheService: CreazionePraticaTipologicheService) { }

  @Input() request;
  @Input() fascicolo;
  @Input() inserimento;
  @Input() datiGeneraliForm: FormGroup;
  @Output() changedFondoRischiState = new EventEmitter();
  componentDestroyed$: Subject<void> = new Subject<void>();
  isPraticaCivile:boolean = false;
  isPraticaPareristico:boolean = false;
  isPraticaAmministrativa:boolean = false;
  isPraticaTributario = false;
  isPraticaLavoro:boolean = false;
  tipiNatura: TipoNatura[] = [];
  tipiVisibilitaOptions: TipoVisibilita[] = [];
  entities: ElaborationDocumentFilterEntity[] = [];
  subscriptionViewManagerTipoPratica: Subscription;
  private motivazioneOptions: TipoMotivazione[] = [];

  ngOnInit() {
    this.addFormControl();
    if (this.tipiNatura.length === 0) {
      this.tipologicheService.getTipiNatura().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => this.tipiNatura = response);
    }
    if (this.motivazioneOptions.length === 0){
      this.helpers.getTipoMotivazione().subscribe(response => this.motivazioneOptions = response);
    }
    if(AppData.getInstance().tipiVisibilitaOptions.length > 0) {
      this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
    } else {
      this.helpers.getRolesByUserData().subscribe(
        () => {
          this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
        }
      )
    }
    if(this.creazionePraticaStoreService.fromWizard){
      this.creazionePraticaStoreService.entities$.subscribe(entities => {
        if (entities) {
          this.entities = filterElaborationEntityClean(entities, [ElaborationEntityConstants.CASE_NUMBER,
            ElaborationEntityConstants.AUT_GIUDIZIARIA,
            ElaborationEntityConstants.JUDGE ,
            ElaborationEntityConstants.COURT_SECTION]);
        }
      });
    }
    this.checkRoute();
    const flagCostituzioneControl = this.datiGeneraliForm.get('flagCostituzione'); // controllo fatto perchè non tutti i fascicoli hanno questo campo
    if (flagCostituzioneControl) {
      this.request.fascicolo.flagCostituzione = this.request.fascicolo.flagCostituzione ?? true;
      flagCostituzioneControl.setValue(this.request.fascicolo.flagCostituzione);
    } 
  }

  checkRoute(): void {
    const url = this.router.url.toLowerCase();
    this.isPraticaCivile = url.includes('civile');
    this.isPraticaLavoro = url.includes('lavoro');
    this.isPraticaPareristico = url.includes('pareristica');
    this.isPraticaAmministrativa = url.includes('amministrativa');
    this.isPraticaTributario = url.includes('tributario');

    this.creazionePraticaStoreService.tipoPratica$
    .pipe(take(1))
    .subscribe(tipo => {
      const endpoint = tipo?.endpoint?.toLowerCase();
      if (endpoint) {
        this.isPraticaCivile = endpoint === 'civile';
        this.isPraticaLavoro = endpoint === 'lavoro';
        this.isPraticaPareristico = endpoint === 'pareristica';
        this.isPraticaAmministrativa = endpoint === 'amministrativa';
        this.isPraticaTributario = endpoint === 'tributario';
      }
    });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  changedFondoRischiStateFn(event){
    this.changedFondoRischiState.emit(event);
  }

  addFormControl(){
    this.datiGeneraliForm.addControl('dataNotifica', new UntypedFormControl(''));
    if(this.fascicolo.tipoFascicolo.categoria.id != 'CONSULENZA'){
      this.datiGeneraliForm.controls['natura'].setValidators([Validators.required]);
    }
  }

  onFlagCostituzioneChange(value: any) {
    this.datiGeneraliForm.get('flagCostituzione').setValue(value);
    this.checkMotivazioneRequired();
    this.datiGeneraliForm.get('flagCostituzione').updateValueAndValidity();
  }

  onMotivazioneChange(value: any) {
    this.datiGeneraliForm.get('motivazione').setValue(value);
  }

  checkMotivazioneRequired() {
    const flagCostituzione = this.datiGeneraliForm.get('flagCostituzione').value;
    if (!flagCostituzione) {
      this.datiGeneraliForm.get('motivazione').setValidators([Validators.required]);
      this.datiGeneraliForm.get('motivazione').updateValueAndValidity();
    } else {
      this.datiGeneraliForm.get('motivazione').clearValidators();
      this.datiGeneraliForm.get('motivazione').updateValueAndValidity();
      this.datiGeneraliForm.get('motivazione').setValue(null);
      this.request.fascicolo.motivazione = null;
    }
  }

}
